export class UserDetails {
    role = "";
    companyId = "";
    username = "";
    uniqueID = "";
    teams: Team[] = [];
}

export class Team {
    teamId = "";
    channel = "";
    name = "";
}

export class Member {
    name = "";
    email = "";
    teams: string[] = [];
    uniqueId = "";
    allowReporting = false;
    isOffPlatform = false;
}

export class Stamp {
    bureauMarket = "";
    bureauMarketCode = "";
    bureauSubMarket = "";
    businessUnit = "";
    stampType = "";
    uniqueID = "";
}

export class CorpSettings {
    allowedEmailDomains : string[] = [];
    authProvider : string = "";
    canViewOfflineTeams : boolean = false;
    digitiseOnlyToTemplate : boolean = false;
    mandatoryAuthStages : string[] = [];
}

export class Corporate {
    _id = "";
    companyId = "";
    role = "";
    name = "";    
    admins: string[] = [];
    members: Member[] = [];
    teams: Team[] = [];
    stamps: Stamp[] = [];
    settings: CorpSettings | null = null;
    permissions: any = null;

    static getTeamsWhereIsSecondApprover( corp : Corporate, muid : string ) : string[] {
        const result : string[] = [];
        if( !corp.settings?.mandatoryAuthStages || !corp.permissions?.secondApprovalSelfApprovers?.teams ) {
            return result;
        }
        const sart = corp.permissions.secondApprovalSelfApprovers.teams;
        Object.keys( sart ).forEach( teamID => {
            if( sart[ teamID ].includes( muid ) ) {
                result.push( teamID );
            }
        });
        return result;
    }
}

export const Session = {
    userDetails : new UserDetails(),
    corporate : new Corporate()
}

